// extracted by mini-css-extract-plugin
module.exports = {"button":"StripeConnectButton_button__1gJ_p","loading":"StripeConnectButton_loading__eu4zm"};